import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { BasicError, err, isError } from "@nju/result";
import { IActivateOrderResult } from "./types";
import {
  mobileOrchestrator as serverResponse,
  verificationErrorResponse,
} from "./validators";

interface IActivateOrder {
  orchestratorId: string;
}

export async function activateOrder({
  orchestratorId,
}: IActivateOrder): Promise<IActivateOrderResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/ORDER_ACTIVATE`,
    {
      method: "post",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);

    const errorInfo = verificationErrorResponse.safeParse(
      result.err.extra?.json,
    );

    if (errorInfo.success && errorInfo.data.code === "50133") {
      return err(
        new BasicError({
          message: "Funds on digital wallet are insufficient",
          code: "DW_INSUFFICIENT_FUNDS",
        }),
      );
    }

    return result;
  }

  return result;
}
